import React, { useState, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import config from '@plone/registry';

interface ContentTypeIconProps {
  item: object;
}

const ContentTypeIcon: React.FC<ContentTypeIconProps> = ({ item }) => {
  if (item?.['@type']) {
    const icon = config.settings.iovisit.contentTypeSiteIcons[item['@type']];
    if (icon) {
      return (
        <FontAwesomeIcon icon={[icon.prefix, icon.name]} className="icon" />
      );
    }
  }
  return null;
};

export default ContentTypeIcon;
